import { get } from "svelte/store"
import { emailRegex, phoneRegex } from "../../../../config"
import { location, newNotification } from "../../../store"

export function checkPassword(password: string): string | null {
    if (password.length < 7) return "Das Passwort muss mindestens 7 Zeichen lang sein."

    const hasAlphabetic = /[a-zA-Z]/.test(password)
    if (!hasAlphabetic) return "Das Passwort muss mindestens einen alphabetischen Buchstaben enthalten."

    const hasNumeric = /[0-9]/.test(password)
    if (!hasNumeric) return "Das Passwort muss mindestens eine Zahl enthalten."

    return null
}

export function validateEmail(email: string): string | null {
    return emailRegex.test(email) ? null : "Email hat kein gültiges Format."
}

export function validatePhone(phone: string): string | null {
    return !phone ? null : phoneRegex.test(phone) ? null : "Telefonnummer hat kein gültiges Format."
}

export function validateInput(input: string): string | null {
    return input?.length > 0 ? null : "Dieses Feld ist erforderlich."
}

export function validateDataProtection(checked: boolean): string | null {
    return checked ? null : "Bitte akzeptiere die Datenschutzbestimmungen."
}

export function onChange(e: Event, element = e.currentTarget as HTMLInputElement) {
    const el = element
    el.classList.remove("error")

    const parent = el.parentElement
    const errorNode = parent?.querySelector(".error-message")
    if (errorNode) {
        parent?.removeChild(errorNode)
    }
}

export function removeAllErrors(form: HTMLFormElement) {
    const errorNodes = form.querySelectorAll(".error-message")
    errorNodes.forEach((node) => node.remove())

    const errorInputs = form.querySelectorAll(".error")
    errorInputs.forEach((input) => input.classList.remove("error"))
}

export function appendErrorMessage(
    element: HTMLInputElement | HTMLDivElement,
    message: string,
    parentEl?: HTMLElement
) {
    const parent = parentEl || element.parentElement
    if (parent) {
        let existingErrorNode = parent.querySelector(".error-message")
        if (existingErrorNode) {
            existingErrorNode.textContent = message
        } else {
            const errorNode = document.createElement("div")
            errorNode.className = "error-message"
            errorNode.textContent = message
            parent.appendChild(errorNode)
        }
    }
}
export function getQueryParam(param: string) {
    return new URLSearchParams(get(location).search).get(param)
}
export function validateField(
    elementId: string,
    value: string | boolean,
    validator: (value: string | boolean) => string | null
): boolean {
    const element = document.getElementById(elementId) as HTMLInputElement
    const error = validator(value)
    if (error) {
        element.classList.add("error")
        appendErrorMessage(element, error)
        newNotification({ html: error, class: "error" })
        return false
    }
    return true
}

export function validateAddress(address: BigCommerceAddress): boolean {
    const validations = [
        { id: "firstName", value: address.first_name, validator: validateInput },
        { id: "lastName", value: address.last_name, validator: validateInput },
        { id: "address1", value: address.address1, validator: validateInput },
        { id: "postalCode", value: address.postal_code, validator: validateInput },
        { id: "city", value: address.city, validator: validateInput },
        { id: "phone", value: address.phone, validator: validatePhone },
    ]

    let isValid = true

    for (const { id, value, validator } of validations) {
        // @ts-ignore
        if (!validateField(id, value, validator)) isValid = false
    }
    return isValid
}

export function createEmptyAddress(): BigCommerceAddress {
    return {
        first_name: "",
        last_name: "",
        address1: "",
        address2: "",
        city: "",
        country_code: "DE",
        postal_code: "",
        phone: "",
        address_type: "residential",
        company: "",
        country: "germany",
        customer_id: undefined,
        state_or_province: undefined,
        id: undefined,
        form_fields: [],
    }
}
